import React, { createContext } from "react";
import { EMPTY_OBJ } from "../helpers/logic/empties";
import useTheme from "./hooks/useTheme";
import { jsx as _jsx } from "react/jsx-runtime";
var ThemeContext = /*#__PURE__*/createContext({
  theme: "light",
  cycleTheme: function cycleTheme() {
    return null;
  }
});
function ThemeProvider(_ref) {
  var children = _ref.children,
    config = _ref.config;
  var _ref2 = config || EMPTY_OBJ,
    themeOverride = _ref2.themeOverride;
  var themeContextValue = useTheme(themeOverride);
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: themeContextValue,
    children: children
  });
}
export { ThemeProvider, ThemeContext };